import { Pool } from "../../../Utils/Collections/Pool";
import { BgRing } from "./BgRing";
import { WrappedArray } from "../../../Utils/Collections/WrapperArray";
import { View } from "../View/View";

export class BgRingManager {
    private _ringPool: Pool<BgRing>;
    private _actRings: WrappedArray<BgRing>;

    private _nextRingViewPos: number;
    private _nextRingId: number;

    private _prevViewZ: number;

    /**
     * Offset od dolni pozice view, pri ktere dojde k deaktivaci prstence
     */
    static readonly RING_DEACT_VIEW_OFFSET = 0;

    /**
     * Offset od dolni pozice view, pro aktivaci noveho prstence
     */
    static readonly RING_ACT_VIEW_OFFSET = -30;

    /**
     * Aktivacni rozestup prstencu
     */
    private static readonly _RING_ACT_INTERVAL = -10;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._ringPool = new Pool<BgRing>(BgRing, 3, true);
        this._actRings = new WrappedArray<BgRing>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Deaktivovat prstence
        this._actRings.forEach((ring: BgRing) => {
            ring.reset();
            this._ringPool.returnItem(ring);
        });
        this._actRings.clear(false);

        // Ulozit aktualni pozici view
        this._prevViewZ = View.instance.botZ;

        // Pripravit aktivaci prvniho prstence
        this._nextRingViewPos = this._prevViewZ;
        this._nextRingId = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        let viewZ = View.instance.botZ;
        let viewStep = this._prevViewZ - viewZ;

        // Zpracovani aktivnich prstencu
        this._actRings.forEach((ring: BgRing) => {
            if (!ring.update(viewZ, viewStep)) {
                this._actRings.remove(false);
                this._ringPool.returnItem(ring);
            }
        });

        // Aktivace noveho prstence
        while (viewZ <= this._nextRingViewPos) {
            let ring = this._ringPool.getItem();

            ring.activate(this._nextRingId++, this._nextRingViewPos + BgRingManager.RING_ACT_VIEW_OFFSET);
            this._actRings.add(ring);

            this._nextRingViewPos += BgRingManager._RING_ACT_INTERVAL;
        }
    }
}